const benefits = [
  {
    icon: 'ri-flashlight-fill',
    title: 'Fast Response Times',
    desc: 'For emergencies, we aim to arrive within 45 minutes across Worksop. You\'ll never be left waiting in the dark.',
  },
  {
    icon: 'ri-money-pound-circle-fill',
    title: 'Honest, Transparent Pricing',
    desc: 'No hidden charges or surprise bills. We give you a clear quote before any work begins so you always know the cost.',
  },
  {
    icon: 'ri-brush-fill',
    title: 'Tidy, Professional Work',
    desc: 'We treat your home with respect. All work is neat, cables are managed properly, and we clean up fully after every job.',
  },
  {
    icon: 'ri-shield-check-fill',
    title: 'Fully Qualified & Insured',
    desc: 'NAPIT registered, Part P registered, and fully insured. Every job is certified and compliant with UK wiring regulations.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-20 bg-white font-body">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-xl overflow-hidden border-4 border-gold-200" style={{ height: '520px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/55cb981fca207793e1379d223047a6f5.jpg"
                alt="Reliable electrician Worksop"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-4 bg-navy-800 border-4 border-gold-400 text-white rounded-xl p-5 w-40 text-center">
              <p className="font-heading font-extrabold text-gold-400 text-3xl leading-none">15+</p>
              <p className="text-gold-100/80 text-xs font-bold uppercase mt-1">Years in<br />Worksop</p>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <span className="inline-block bg-gold-100 text-gold-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5 border border-gold-200">
              Why Choose Us
            </span>
            <h2 className="font-heading font-extrabold text-navy-800 mb-6" style={{ fontSize: 'clamp(2rem, 4vw, 2.8rem)' }}>
              Why Worksop Trusts Us With Their Electrics
            </h2>
            <p className="text-navy-600/60 leading-relaxed mb-8">
              We&apos;re not a faceless national company. We&apos;re your local electrician — someone you can actually talk to, who turns up on time and does the job right first time.
            </p>

            <div className="space-y-6">
              {benefits.map((b) => (
                <div key={b.title} className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-navy-800 rounded-lg flex-shrink-0">
                    <i className={`${b.icon} text-gold-400 text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-navy-800 text-lg mb-1">{b.title}</h3>
                    <p className="text-navy-600/60 text-sm leading-relaxed">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
